<template>
	<div  v-if="imgSrc">
		<img :src="imgSrc" alt="" style="max-width: 50px;  max-height: 40px" @click="onResimGoster" />
		<vs-popup :active.sync="activePrompt">
			<img :src="imgSrc" style="width: 100%" />
		</vs-popup>
	</div>
</template>
<script>
export default {
	data() {
		return {
			imgSrc: "",
			activePrompt: false
		};
	},
	created() {
		this.imgSrc = "data:image/jpeg;base64," + this.params.data.CompanyLogo;
	},
	methods: {
		onResimGoster() {
			this.activePrompt = true
		},
	}
};
</script>